export default  {
   'apiurl':"https://store-api.gallerystore.pl",
   'release': "dev"
};
